export default __webpack_public_path__ + "img/61f74b85aa21c455ee64109eaec4730c.svg";